/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import PropTypes from 'prop-types';

import Swatch from '@salesforce/retail-react-app/app/components/swatch-group/swatch';

/**
 * @override
 *  - Add new variant values to Swatch component
 */
Swatch.propTypes = {
  ...Swatch.propTypes,

  /**
   * The shape of the Swatch
   */
  variant: PropTypes.oneOf(['square', 'circle', 'card', 'list-item']),
};

export default Swatch;
